import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import Reviews from './pages/Reviews';
import ReviewAnalytics from './pages/ReviewAnalytics';
import CategoryInsights from './pages/CategoryInsights';
import LoginPage from './pages/LoginPage';
import PrivateRoute from './components/auth/PrivateRoute';
import Settings from './pages/Settings';
import AdvancedCategoryInsights from './pages/AdvancedCategoryInsights';
import CategoryAnalytics from './components/category-insights/CategoryAnalytics';
import Cat from './pages/Cat';
import { DataProvider, useData } from './contexts/DataContext';
import DataLoader from './components/common/DataLoader';

// App content component that uses the data context
const AppContent = () => {
  const { isLoading, progress, error, retry } = useData();

  // Show global loading screen when data is being loaded
  if (isLoading || error) {
    return (
      <DataLoader
        isLoading={isLoading}
        progress={progress}
        error={error}
        title="Loading Data"
        subtitle="Preparing your analytics dashboard..."
        size="large"
      />
    );
  }

  return (
    <Router>
      <Routes>
        {/* Public route for login */}
        <Route path="/login" element={<LoginPage />} />
        
        {/* Private routes that require authentication */}
        <Route element={<PrivateRoute />}>
          <Route element={<Layout />}>
            {/* <Route path="/" element={<Dashboard />} /> */}
            <Route path="/reviews" element={<Reviews />} />
            {/* <Route path="/analytics" element={<ReviewAnalytics />} /> */}
            {/* <Route path="/insights" element={<CategoryInsights />} /> */}
            {/* <Route path="/advanced-insights" element={<AdvancedCategoryInsights />} /> */}
            <Route path="/" element={<Cat />} />
            {/* <Route 
              path="/category-comparison" 
              element={
                <div className="py-6 px-4">
                  <h1 className="text-2xl font-bold text-indigo-800 mb-6">Category Performance</h1>
                  <div className="bg-white rounded-lg shadow-sm p-6">
                    <CategoryAnalytics />
                  </div>
                </div>
              } 
            /> */}
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Route>
        
        {/* Catch all route - redirect to login or dashboard based on auth status */}
        <Route 
          path="*" 
          element={
            localStorage.getItem('isAuthenticated') === 'true' 
              ? <Navigate to="/" replace /> 
              : <Navigate to="/login" replace />
          } 
        />
      </Routes>
    </Router>
  );
};

function App() {
  return (
    <DataProvider>
      <AppContent />
    </DataProvider>
  );
}

export default App;